<template>
    <div id="yelp-review-content">
        <vs-col class="w-2/3 pr-6" v-if="yelpReviewList.length != 0">
            <div v-for="(review, index) in yelpReviewList" :key="index">
              <item-yelp-review :reviewData="review"></item-yelp-review>
          </div>
          <div class="my-3" v-if="reviewData._meta.pageCount && reviewData._meta.pageCount > 1">
            <custom-pagination class="custom-pagination mt-6" :totalPages="parseInt(reviewData._meta.pageCount)" :currentPage="curPage" @pageChanged="changePage" :key="page_key"></custom-pagination>
          </div>
        </vs-col>

        <vs-col class="w-2/3 pr-6 text-center mt-base" v-else>
            No data available
        </vs-col>

        <vs-col class="w-1/3 right-col" v-if="reviewReport">
            <vx-card class="mb-6 mt-3" v-if="reviewReport.yelp_review_rating">
              <div class="flex">
                <star-rating :rating="5" :read-only="true" :increment="1" active-color="#EA5455" class="mr-3"></star-rating>
                <span class="mt-2 d-inline-block review-rating">{{reviewReport.yelp_review_rating.five_star}} Reviews</span>
              </div>
              <div class="flex">
                <star-rating :rating="4" :read-only="true" :increment="1" active-color="#EA5455" class="mr-3"></star-rating>
                <span class="mt-2 d-inline-block review-rating">{{reviewReport.yelp_review_rating.four_star}} Reviews</span>
              </div>
              <div class="flex">
                <star-rating :rating="3" :read-only="true" :increment="1" active-color="#EA5455" class="mr-3"></star-rating>
                <span class="mt-2 d-inline-block review-rating">{{reviewReport.yelp_review_rating.three_star}} Reviews</span>
              </div>
              <div class="flex">
                <star-rating :rating="2" :read-only="true" :increment="1" active-color="#EA5455" class="mr-3"></star-rating>
                <span class="mt-2 d-inline-block review-rating">{{reviewReport.yelp_review_rating.two_star}} Reviews</span>
              </div>
              <div class="flex">
                <star-rating :rating="1" :read-only="true" :increment="1" active-color="#EA5455" class="mr-3"></star-rating>
                <span class="mt-2 d-inline-block review-rating">{{reviewReport.yelp_review_rating.one_star}} Reviews</span>
              </div>
            </vx-card>
          </vs-col>
    </div>
</template>

<script>
  import StarRating from "vue-star-rating";
  export default {
      name: 'yelp-review-content',
      components: {
        StarRating,
      },
      props: {
        search: {
          type: String
        },
        sort_by: {
          type: Object
        },
        currentPage: {
          type: Number,
          default: 1
        },
        itemsPerPage: {
          type: Number
        }
      },
      data() {
        const obj = {
          page: this.currentPage,
          "per-page": this.itemsPerPage,
          user_name: this.search,
          type: 'yelp'
        }
        if(this.sort_by && this.sort_by.id != 0) {
          obj.sort = this.sort_by.value;
        }
        this.$store.dispatch("reviewList/GET_REVIEW_LIST", obj).then(() => {
          this.$emit('GetDataComplete');
        });
        return {
          curPage: this.currentPage,
          isOpenLoading: false,
          page_key: 0
        }
      },
      methods: {
        openLoadingInDiv(){
            this.$vs.loading({
              container: '#list-review',
              scale: 0.8
            })
            if (this.loadTime) {
              clearTimeout(this.loadTime);
              this.loadTime = null;
            }
            this.isOpenLoading = true;
            this.loadTime = setTimeout( ()=> {
              if(this.isOpenLoading) {
                this.closeLoading();
                this.$vs.dialog({
                  color: 'danger',
                  title: 'Notification',
                  text: 'Get list yelp review failed',
                  acceptText: 'OK'
                })
              }
            }, 10000);
          },
          closeLoading() {
            this.$vs.loading.close('#list-review > .con-vs-loading');
            this.isOpenLoading = false;
          },
          changePage(curPage) {
            const obj = {
                page: curPage,
                "per-page": this.itemsPerPage,
                user_name: this.search,
                type: 'yelp'
            }
            if(this.sort_by && this.sort_by.id != 0) {
              obj.sort = this.sort_by.value;
            }
            if(!this.isOpenLoading) {
              this.openLoadingInDiv();
            }
            this.$store.dispatch("reviewList/GET_REVIEW_LIST", obj).then(() => {
              this.closeLoading();
              this.$emit('ChangePage', curPage);
              this.page_key++;
            })
        },
      },
      computed: {
        yelpReviewList() {
          return this.$store.getters["reviewList/reviewList"];
        },
        reviewData() {
          return this.$store.getters["reviewList/reviewData"];
        },
        reviewReport() {
          return this.$store.getters['reviewList/reviewReport'];
        }
      },
      created() {
        this.$emit('ChangeReview', 'yelp');
      }
  }
</script>